<!--Opciones perfil-->
<div class="social-panel iguau-profile-actions mt-3" *ngIf="perfil.ID != misdatos.ID" [class.blur-strong]="misdatos.perfilPublico == 'no_publico'">
  <div class="social-stats">
    <!--NUMERO DE VISITAS-->
    <!--<div class="div-stat ms-2 me-2 mb-2" title="Número de visitas">
      <i class="fa-eye"
        [ngClass]="{'fa-regular': perfil.datos.visitas_total == 0, 'fa-solid text-iguau': perfil.datos.visitas_total > 0}"></i>
      <span class="ms-1">{{perfil.datos.visitas_total}}</span>
      <span class="ms-1">visita<span *ngIf="perfil.datos.visitas_total > 1 || perfil.datos.visitas_total == 0">s</span></span>
    </div>-->
    <!--NUMERO DE AMIGOS-->
    <div class="div-stat me-2 mb-2 pointer" title="Número de amigos" 
        [title]="perfil.losigo == 'activo' ? 'Ya eres amigo de este perfil' : perfil.losigo == 'pendiente' ? 'Esperando amistad' : 'Enviar solicitud de amistad'"
        (click)="seguir()">
      <i class="fa-regular fa-face-smile" [class.text-success]="perfil.losigo == 'activo'" [class.text-iguau]="perfil.losigo == 'pendiente'"></i>
      <i class="fa-regular fa-clock text-iguau" *ngIf="perfil.losigo == 'pendiente'"></i>
      <i class="fa-solid fa-check text-success" *ngIf="perfil.losigo == 'activo'"></i>
      <span class="ms-1">{{perfil.datos.amigos}}</span>
      <span class="d-none d-lg-inline ms-1"><span class="ms-1">amigo<span *ngIf="perfil.datos.amigos > 1 || perfil.datos.amigos == 0">s</span></span></span>
    </div>
    <!--HUELLAS-->
    <div class="div-stat me-2 mb-2 pointer" title="Dejar huella" (click)="dejarHuella()">
      <i class="fa-solid fa-paw me-1" [class.text-iguau]="perfil.mihuella > 0"></i>{{perfil.huellas}}
      <span class="d-none d-lg-inline ms-1">huella<span *ngIf="perfil.huellas > 1 || perfil.huellas == 0">s</span></span>
    </div>
    <!--COMPARTIR-->
    <div class="div-stat me-2 mb-2 pointer" data-bs-toggle="modal" data-bs-target="#compartirModal" title="Compartir perfil">
      <i class="fa-solid fa-share-nodes"></i>
      <span class="d-none d-lg-inline ms-1">Compartir</span>
    </div>
  </div>
</div>
<!--************************************************************************-->
<!--Opciones mi perfil-->
<div class="social-panel social-stats mt-3" *ngIf="perfil.ID == misdatos.ID">
  <!--Mensajes-->
  <div class="div-stat pointer" data-bs-toggle="modal" data-bs-target="#mensajesModal"
    [ngClass]="{'text-secondary': perfil.datos.mensajes == 0}">
      <i class="fa-comments" 
      [ngClass]="{'fa-regular': perfil.datos.mensajes == 0, 'fa-solid text-success vibrate-icon': perfil.datos.mensajes > 0}"
      ></i> 
    <span class="ms-1" *ngIf="perfil.datos.mensajes > 0">
      {{ perfil.datos.mensajes > 99 ? '+99' : perfil.datos.mensajes }}
    </span>
    <span class="d-none d-lg-inline">
      mensaje<span *ngIf="perfil.datos.mensajes > 1 || perfil.datos.mensajes == 0">s</span>
      <!--nuevo<span *ngIf="datos.mensajes > 1 || datos.mensajes == 0">s</span>-->
    </span>
  </div>
  <!-- Botón Notificaciones desactivado temporalmente. Descomentar para recuperarlo.
  <div class="div-stat pointer" data-bs-toggle="modal" data-bs-target="#notificacionesModal">
    <div *ngIf="perfil.datos.notificaciones > 0">
      <i class="fa-solid fa-bell text-success vibrate-icon"></i>
      <span class="ms-1">{{perfil.datos.notificaciones}}</span>
      <span class="d-none d-lg-inline ms-1">
        notificaci<span *ngIf="perfil.datos.notificaciones == 1">ón</span><span *ngIf="perfil.datos.notificaciones > 1">ones</span>
      </span>
    </div>
    <div *ngIf="perfil.datos.notificaciones == 0" [ngClass]="{'text-secondary': perfil.datos.notificaciones_total == 0}">
      <i class="fa-solid fa-bell"></i>
      <span class="d-none d-lg-inline ms-1">Notificaciones</span>
    </div>
  </div>
  -->
  <!-- Amistades y solicitudes pendientes: mismo modal -->
  <div class="div-stat pointer iguau-amigos-action"
       data-bs-toggle="modal" data-bs-target="#amigosModal"
       [ngClass]="{'text-secondary': (+perfil?.datos?.amigos || 0) === 0 && (+perfil?.datos?.solicitudes || 0) === 0}"
       [attr.title]="(+perfil?.datos?.solicitudes || 0) > 0 ? 'Amigos y solicitudes pendientes de aceptar' : 'Ver mis amigos'"
       [attr.aria-label]="'Amigos: ' + (+perfil?.datos?.amigos || 0) + '. Solicitudes pendientes: ' + (+perfil?.datos?.solicitudes || 0)"
       role="button" tabindex="0">
    <i class="fa-regular fa-face-smile" [class.text-iguau]="(+perfil?.datos?.amigos || 0) > 0" aria-hidden="true"></i>
    <span class="ms-1">{{ +perfil?.datos?.amigos || 0 }}</span>
    <span class="d-none d-lg-inline ms-1">amigo<span *ngIf="(+perfil?.datos?.amigos || 0) !== 1">s</span></span>
    <span *ngIf="(+perfil?.datos?.solicitudes || 0) > 0"
          class="iguau-solicitudes-badge"
          [attr.aria-label]="(+perfil?.datos?.solicitudes || 0) + ' solicitudes pendientes'"
          [title]="(+perfil?.datos?.solicitudes || 0) + ' solicitudes pendientes de aceptar'">
      <i class="fa-solid fa-user-clock" aria-hidden="true"></i>
      {{ +perfil?.datos?.solicitudes || 0 }}
      <span class="d-none d-xl-inline">pendiente<span *ngIf="(+perfil?.datos?.solicitudes || 0) !== 1">s</span></span>
    </span>
  </div>
  <!--Huellas-->
  <div class="div-stat pointer" data-bs-toggle="modal" data-bs-target="#huellasModal"
    [ngClass]="{'text-secondary': perfil.huellas == 0, 'text-success': perfil.huellas_nuevas > 0}">
    <i class="fa-solid fa-paw" [class.text-iguau]="perfil.mihuella > 0 || perfil.huellas > 0"></i>
    <span class="ms-1">{{perfil.huellas}}</span>
    <span class="d-none d-lg-inline ms-1">huella<span *ngIf="perfil.huellas > 1 || perfil.huellas == 0">s</span></span>
    <span class="d-none d-lg-inline ms-0" *ngIf="perfil.huellas_nuevas > 0">, {{perfil.huellas_nuevas}} nueva<span *ngIf="perfil.huellas_nuevas > 1 || perfil.huellas_nuevas == 0">s</span></span>
  </div>
  <!--Visitas-->
  <div class="div-stat pointer align-items-center pointer" data-bs-toggle="modal" data-bs-target="#visitasModal"
      [ngClass]="{'text-secondary': perfil.datos.visitas_nuevas == 0}">
    <i class="fa-eye"
      [ngClass]="{'fa-regular': perfil.datos.visitas_total == 0, 'fa-solid text-iguau': perfil.datos.visitas_total > 0}"></i>
    <span class="ms-1">{{perfil.datos.visitas_total}}</span>
    <span class="d-none d-lg-inline ms-1">
      visita<span *ngIf="perfil.datos.visitas_total > 1 || perfil.datos.visitas_total == 0">s</span><span *ngIf="perfil.datos.visitas_nuevas > 0">, {{perfil.datos.visitas_nuevas}} nueva<span *ngIf="perfil.datos.visitas_nuevas > 1 || perfil.datos.visitas_nuevas == 0">s</span></span>
    </span>
  </div>
</div>
